<template>
    <base-section header="Program svatby" class="items">
        <v-layout column v-for="day in days" :key="day.name">
            <v-flex text-xs-center class="day"><text-striked>{{day.name}}</text-striked></v-flex>
            <v-flex>
                <v-layout
                        :wrap="$vuetify.breakpoint.xsOnly"
                        class="item"
                        v-for="item in day.items"
                        :key="item.name"
                        :class="{important: item.important}"
                >
                    <v-flex xs12 sm4 class="time">{{item.time}}</v-flex>
                    <v-flex xs12 sm8 class="content-wrapper">
                        <v-layout class="content" column>
                            <v-flex class="name">{{item.name}}</v-flex>
                            <v-flex class="description" v-if="item.description">({{item.description}})</v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
    </base-section>
</template>
<script>
    import BaseSection from "@/components/BaseSection"
    import TextStriked from "@/components/TextStriked";

    export default {
        name: 'section-programme',
        components: {TextStriked, BaseSection},
        data() {
            return {
                days: [{
                    name: "Sobota",
                    items: [{
                        time: "10:00 - 11:00",
                        name: "Přivítání a ubytování hostů"
                    }, {
                        time: "12:00",
                        name: "Předsvatební hostina",
                        important: true
                    }, {
                        time: "od 13:30",
                        name: "Odpolední káva a minizákusky"
                        // Anett příprava, líčení
                    }, {
                        time: "15:00",
                        name: "Obřad",
                        important: true
                    }, {
                        time: "15:30",
                        name: "Hromadné focení"
                    }, {
                        time: "15:45",
                        name: "Nakrojení svatebního dortu"
                        // My se půjdeme fotit
                    }, {
                        time: "od 16:00",
                        name: "Živá hudba",
                        description: "Lukáš, Míša, Adam"
                    }, {
                        time: "17:00 - 17:30",
                        name: "Fotograf Jakub ve fotokoutku pro svatebčany",
                    }, {
                        time: "od 17:30",
                        name: "Grilované sele",
                    }, {
                        time: "18:30",
                        name: "Kvíz pro hosty",
                        description: "Focení nevěsty a ženicha v terénu"
                    }, {
                        time: "20:00",
                        name: "Zábava u baru, kapela, soutěže ...",
                    }, {
                        time: "dle únavy",
                        name: "Přespání v zámeckých pokojích"
                    }]
                }, {
                    name: "Neděle",
                    items: [{
                        time: "8:00 - 11:00",
                        name: "Snídaně"
                    },{
                        time: "11:00",
                        name: "Pro zájemce výšlap na zříceninu Kalich"
                    }]
                }]
            }
        },
    }
</script>
<style scoped lang="stylus">
    .items {

        .day {
            margin-top: 1.5rem;
        }

        .item {
            line-height: 1.5em;


            > * {
                margin: 0.15rem;
            }

            .time {
                text-align: right;
                margin-right: 0.5rem;
            }

            .description {
                font-size: 0.85rem
            }

            &.important {
                .time, .name {
                    font-weight: bold;
                }
            }
        }

        @media screen and (max-width: 600px) {
                .item {
                    .time, .content {
                        text-align: center
                    }
                    .time {
                        margin-bottom: 0;
                        margin-top: 0.5rem;
                        font-size: 1.25rem;
                    }
                    .content-wrapper {
                        margin-top: 0;
                    }
                }
        }
    }
</style>